
    import '/opt/buildhome/repo/packages/x/docs/react/agent-use-tbox.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-react-agent-use-tbox-demo-tbox"],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/react/agent-use-tbox.en-US.md?type=demo')
};